import { ModalsCtxData } from '@/types/modals';

export const MODALS_DEFAULT_STATE: ModalsCtxData['modalsState'] = {
  initialSearch: false,
};
